export class FiltroGenerarPedido {
    cliente: number;
    clienteDescripcion: string;
    fechaInicio: Date;
    fechaFin: Date;
    vendedor: number;
    cotizacion: string;

    constructor() {

    }
}